import { useCallback } from 'react';
import { useTrackEventMutation } from 'app/data/mutations/use-track-event-mutation';
import { WebClickProperties, WebClickTrackEvent } from 'app/data/types/tracking';

export const useTrackWebClick = (): ((properties: WebClickProperties) => void) => {
  const { trackEvent } = useTrackEventMutation();

  return useCallback(
    (properties: WebClickProperties) => {
      const event: WebClickTrackEvent = {
        type: 'action',
        event_type: 'track_v2_web_click',
        properties,
      };

      trackEvent(event);
    },
    [trackEvent],
  );
};
